import { gsap } from 'gsap/dist/gsap'

export default {
  init() {
    
    /**************************************************************
    -> Animate items when filtered
    **************************************************************/
    $(document).on('facetwp-loaded', function() {
      gsap.fromTo('.card', {
        opacity: 0,
      },
      { 
        opacity: 1,
        duration: 1,
        ease: 'linear',
        delay: 0.15,
        stagger: {
          each: 0.15,
          from: 'start',
          ease: 'linear',
        },
      })
    })


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-experiences.js